import { cn } from '@/lib/utils'
import { Stars } from '@/modules/Frontend/Reviews'
import { TextLink } from '@/modules/Frontend/UiBlocks'

import { Skeleton, useProductViewSkeletonVariants } from '../../../../Theme'
import { useProductAttributes } from '../../../state'

export function InfoReviews() {
  const { productAttributes, loading, averageStars, numberOfReviews } = useProductAttributes()
  const { skeletonSectionVariants } = useProductViewSkeletonVariants()

  if (loading) {
    return (
      <div className={skeletonSectionVariants({ section: 'infoLine' })}>
        <Skeleton size="sm" width="full" />
      </div>
    )
  }

  const textClasses = 'font-main-font text-sm xl:text-base text-text-color'

  if (!productAttributes?.reviews?.items?.length) {
    return (
      <TextLink
        variant="underline"
        className="justify-center md:justify-start xl:justify-start gap-2 mb-3 xl:mb-5"
        href="#review-form"
      >
        Scrie o evaluare
      </TextLink>
    )
  }

  const reviewLabel = numberOfReviews > 1 ? 'evaluari' : 'evaluare'

  return (
    <div className="flex flex-row items-center justify-center md:justify-start xl:justify-start gap-1 text-text-color mb-5">
      <Stars totalStars={averageStars} />
      <p className={textClasses}>{averageStars}/5</p>
      <p className={cn(textClasses, 'flex flex-row gap-2 items-center')}>
        {' - '}
        <TextLink className="hidden xl:flex flex-row items-center" href="#productReviews">
          {numberOfReviews} {reviewLabel}
        </TextLink>
      </p>
      <TextLink
        variant="underline"
        className="gap-2"
        href="#review-form"
      >
        Scrie o evaluare
      </TextLink>
    </div>
  )
}
